(function ($) {
  Drupal.behaviors.sppProductLayoutV2 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-spp-product-layout-v2', context);
      var $expanderSections = $('.spp-product-layout__content-item', $template);
      var $ratingsTitle = $expanderSections.find('.js-pr-rating-tab');
      var $ratingsSectionTitle = $expanderSections.find('.js-spp-reviews-content');

      // Populate ratings header
      if ($ratingsTitle.length > 0 && $ratingsSectionTitle.length > 0) {
        $ratingsSectionTitle.html($ratingsTitle.html());
      }

      // section expanders
      if ($expanderSections.length) {
        $expanderSections.each(function () {
          var $this = $(this);
          var $trigger = $this.find('.spp-product-layout__content-item-heading');

          // click handler
          $trigger.once().on('click', function () {
            var $this = $(this);
            var $content = $this.next('.spp-product-layout__content-item-content');
            // Cast the expanded state as a boolean
            var expanded = $this.attr('aria-expanded') === 'false' ? false : true;

            // Switch the states of aria-expanded and aria-hidden
            $this.attr('aria-expanded', !expanded);
            $content.attr('aria-hidden', expanded);
          });
        });
      }
    },
    attached: false
  };
})(jQuery);
